import TemplateView from '../../../../../../TemplateView'
import {connect} from '../../../../../../redux/utils'
import Button from '../../../../../../components/Button'
import messageResource from '../../../../../../messageResource'
import YearSelector from './YearSelector'
import RemoveAllConfirmation from './RemoveAllConfirmation'
import {getHolidays, getPanelSelectedYear, isLoadingHolidayList, isShownRemoveAllConfirm} from '../selectors'
import {closeRemoveAllConfirmation, loadPanelData, openRemoveAllConfirmation, removeAllHolidays} from '../actions'
import {bindActionCreators} from 'redux'
import HolidayListContainer from './HolidayListContainer'
import {WORK_SCHEDULE_YEAR_START} from '../../../../constants'
import {getInstance as importHolidaysDialog} from '../../../ImportHolidaysDialog'
import {loadCountries} from '../../../../actions'
import ScrollableContainer from '../../../../../../util/ScrollableContainer'

class HolidayListPanelContent extends TemplateView {
    constructor({
        openRemoveAllConfirm,
        closeRemoveAllConfirm,
        loadPanelData,
        removeAllHolidays,
        onImportButtonClick = () => {},
    }) {
        super()

        this.actions = {
            openRemoveAllConfirm,
            closeRemoveAllConfirm,
            loadPanelData,
            removeAllHolidays,
            onImportButtonClick,
        }

        this.state = {
            year: '',
            isShownRemoveAllConfirm: false,
            holidays: {},
            loading: false,
        }

        this.onStatePropertyChanged('isShownRemoveAllConfirm', (isShownRemoveAllConfirm) => {
            if (isShownRemoveAllConfirm) {
                this.removeAllConfirmation.setState({
                    year: this.state.year
                })
            }

            this.$holidayListPlaceholder.toggle(!isShownRemoveAllConfirm)
            this.$removeAllConfirmation.toggle(isShownRemoveAllConfirm)

            this.yearSelector.setState({
                decrementDisabled: isShownRemoveAllConfirm,
                incrementDisabled: isShownRemoveAllConfirm,
            })
        })

        this.onAnyStatePropertyChanged(['holidays', 'loading'], () => {
            if (!this.state.loading)
                this.removeAllButton.setState({disabled: Object.keys(this.state.holidays).length === 0})
        })

        this.onStatePropertyDeeplyChanged('year', (year) => {
            this._updateYear(year)
            this.importButton.setState({disabled: year < window.currentUserTime().clearTime().getFullYear()})
        })
    }

    templateHtml() {
        return '<div class="holidayListContainer">' +
               '  <div class="containerTitle">' +
               '    <div class="titleContainer">' +
               '        <div class="selector"></div>' +
               '        <div class="title"><%=holidayList%></div>' +
               '    </div>' +
               '    <div class="buttonContainer">' +
               '        <div class="importButton"/>' +
               '        <div class="removeAllButton"/>' +
               '    </div>' +
               '  </div>' +
               '  <div class="removeAllConfirmation"/>' +
               '  <div class="holidayListPlaceholder"/>' +
               '</div>'
    }

    messageKeys() {
        return {
            holidayList: 'work_schedule.header.holiday_list_button',
        }
    }

    afterRender() {
        this.yearSelector = new YearSelector({
            incrementYear: () => {
                let year = this.state.year + 1
                this._updateYear(year)
                this.actions.loadPanelData(year)
            },
            decrementYear: () => {
                let year = this.state.year - 1
                this._updateYear(year)
                this.actions.loadPanelData(year)
            }
        }).init(this.find('.selector'))

        this.$holidayListPlaceholder = this.find('.holidayListPlaceholder')
        this.holidayList = new HolidayListContainer().init(this.$holidayListPlaceholder)

        this.$removeAllConfirmation = this.find('.removeAllConfirmation')

        this.removeAllConfirmation = new ScrollableContainer(
            null,
            new RemoveAllConfirmation({
                onConfirmButtonClick: () => this.actions.removeAllHolidays(),
                onCancelButtonClick: () => this.actions.closeRemoveAllConfirm()
            })
        ).init(this.$removeAllConfirmation)

        this.importButton = new Button({
            additionalClass: 'import',
            label: messageResource.getMessage('work_schedule.header.import_holidays_button'),
            onClickCb: () => this._showImportDialog(),
            withDisableTooltip: true,
            tooltipAdditionalClass: 'importHolidaysButtonDisabledTooltip',
        }).init(this.find('.importButton'))
        this.importButton.setState({disableTooltipText: messageResource.getMessage('work_schedule.header.import_holidays_button_disabled_tooltip')})

        this.removeAllButton = new Button({
            additionalClass: 'remove',
            label: messageResource.getMessage('work_schedule.remove_all_button'),
            onClickCb: () => this.actions.openRemoveAllConfirm()
        }).init(this.find('.removeAllButton'))

        this.renderInitialState()
    }

    _updateYear(year) {
        this.yearSelector.setState({
            year,
            decrementHidden: year <= WORK_SCHEDULE_YEAR_START,
            incrementHidden: year >= new Date().getFullYear() + 1,
        })
    }

    _showImportDialog() {
        importHolidaysDialog().showAt(
            this.importButton.getEl(),
            {
                my: 'right top',
                at: 'right bottom',
            }
        )
        this.actions.onImportButtonClick()
    }
}

export default connect(
    state => ({
        isShownRemoveAllConfirm: isShownRemoveAllConfirm(state),
        year: getPanelSelectedYear(state),
        holidays: getHolidays(state),
        loading: isLoadingHolidayList(state),
    }),
    dispatch => ({
        openRemoveAllConfirm: bindActionCreators(openRemoveAllConfirmation, dispatch),
        closeRemoveAllConfirm: bindActionCreators(closeRemoveAllConfirmation, dispatch),
        loadPanelData: bindActionCreators(loadPanelData, dispatch),
        removeAllHolidays: bindActionCreators(removeAllHolidays, dispatch),
        onImportButtonClick: bindActionCreators(loadCountries, dispatch),
    }),
)(HolidayListPanelContent)


// WEBPACK FOOTER //
// ./web/js/administration/workSchedule/components/panels/holidayList/components/HolidayListPanelContent.js